// extracted by mini-css-extract-plugin
export default {"heading":"Pv-z","corrected":"Qv-z","redirectVerbiageContainer":"Rv-z","redirectVerbiageText":"Sv-z"};